import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/form-menu.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M19.4453 6.09961C20.8015 6.09978 21.9002 7.19924 21.9004 8.55566V19.4453C21.9002 20.8015 20.8008 21.9002 19.4443 21.9004H8.55566C7.19887 21.9002 6.09979 20.8011 6.09961 19.4443V8.55566C6.09979 7.19887 7.19887 6.09979 8.55566 6.09961H19.4453ZM8.55566 7.90039C8.19299 7.90057 7.90057 8.19299 7.90039 8.55566V19.4443C7.90057 19.807 8.19299 20.0994 8.55566 20.0996H19.4443C19.8074 20.0994 20.0994 19.8066 20.0996 19.4453V8.55566C20.0994 8.1926 19.8066 7.90056 19.4453 7.90039H8.55566ZM17.8896 16.21C18.3867 16.21 18.79 16.6133 18.79 17.1104C18.7898 17.6072 18.3866 18.0107 17.8896 18.0107H10.2197C9.72291 18.0106 9.31953 17.6072 9.31934 17.1104C9.31934 16.6134 9.7228 16.2101 10.2197 16.21H17.8896ZM16 2.09961C16.4971 2.09961 16.9004 2.50294 16.9004 3C16.9004 3.49706 16.4971 3.90039 16 3.90039H5C4.39206 3.90039 3.90039 4.39206 3.90039 5V15C3.90039 15.4971 3.49706 15.9004 3 15.9004C2.50294 15.9004 2.09961 15.4971 2.09961 15V5C2.09961 3.39794 3.39794 2.09961 5 2.09961H16ZM17.8926 9.89258C18.3967 9.94391 18.79 10.37 18.79 10.8877V13.959C18.7898 14.4764 18.3965 14.9028 17.8926 14.9541L17.79 14.96H10.3193L10.2168 14.9541C9.71294 14.9027 9.31958 14.4764 9.31934 13.959V10.8877C9.31934 10.3701 9.71281 9.94404 10.2168 9.89258L10.3193 9.8877H17.79L17.8926 9.89258ZM10.8193 13.46H17.29V11.3877H10.8193V13.46Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as FormMenuIcon };
